<template>
  <div v-if="isVisible" v-outside-click="closePopup" class="filterWrapper" :style="popupStyle">
    <div class="section">
      <div class="filterBox">
        <div v-if="data.sections[0]" class="filterBox__filter" @click="setParent(data.sections[0].id, 0)">
          <radio-box v-if="index == 1" :item="data.sections[0]" />
          <span :class="{ activeTab: index == 0 }">{{ data.sections[0].text }}</span>
        </div>
        <div class="filterBox__devider"></div>
        <div v-if="data.sections[1]" class="filterBox__sort" @click="setParent(data.sections[1].id, 1)">
          <radio-box v-if="index == 0" :item="data.sections[1]" />
          <span :class="{ activeTab: index == 1 }">{{ data.sections[1].text }}</span>
        </div>
      </div>

      <div class="filterBox__seperator"></div>

      <div v-if="data.sections[0] && index == 0" class="section__options">
        <div v-for="(option, i) in data.sections[0].options" :key="i">
          <div class="section__option" :class="{ 'section__option--active': option.id === currentItemID }">
            <radio-box
              :item="option"
              :is-checked="option.id === currentItemID && index === 0"
              @passItem="toggleChildren"
            />
          </div>

          <div v-if="option?.type == 'text' && option.id === currentItemID" class="textFilterWrapper">
            <div class="textfilter">
              <div class="textfilter__input">
                <div :class="{ active: subIndex == 0, isOpen: filterValueDropDown }" class="textfilter__dropdown">
                  <div class="selected" @click="toggleFilterDropDown">
                    <span> {{ startWith }} </span>
                    <i :class="filterValueDropDown ? icons.MenuDown : icons.MenuUp"></i>
                  </div>
                  <select-option
                    v-if="filterValueDropDown"
                    :options="Object.keys(iconTextMatch)"
                    :default="'='"
                    data-test-id="filter-section-in-table"
                    @input="handleFilterCondition"
                    @close="filterValueDropDown = false"
                  />
                </div>
                <input
                  v-if="filterBy === 'text'"
                  ref="startValue"
                  v-model="filterValue"
                  type="text"
                  placeholder="Enter text"
                  data-test-id="enter-text-in-filter"
                  @keydown="handleInputKeyDown"
                />
                <input
                  v-if="filterBy === 'number'"
                  ref="startValue"
                  v-model="filterValue"
                  type="number"
                  placeholder="Enter number"
                  data-test-id="enter-number-in-filter"
                  @keydown="handleInputKeyDown"
                />
                <input
                  v-if="dateInputRequire"
                  ref="startValue"
                  v-model="filterValue"
                  type="date"
                  @keydown="handleInputKeyDown"
                />
                <input
                  v-if="timeInputRequire"
                  ref="startValue"
                  v-model="filterValue"
                  type="time"
                  @keydown="handleInputKeyDown"
                />
              </div>

              <div v-if="filterValue && filterBy !== 'none' && filterBy == 'number'" class="textfilter__andOr">
                <div class="textfilter__text">
                  <radio-box
                    :item="{ id: '17', label: 'AND', value: 'AND' }"
                    :is-checked="filterConditionJoin == 'AND'"
                    @passItem="toggleAndOR"
                  />
                  <radio-box
                    :item="{ id: '18', label: 'OR', value: 'OR' }"
                    :is-checked="filterConditionJoin == 'OR'"
                    @passItem="toggleAndOR"
                  />
                </div>

                <div class="textfilter__input">
                  <div :class="{ active: subIndex == 2, isOpen: filterValueEndDropDown }" class="textfilter__dropdown">
                    <div class="selected" @click="toggleFilterValueEndDropDown">
                      <span> {{ endWith }} </span>
                      <i :class="filterValueEndDropDown ? icons.MenuDown : icons.MenuUp"></i>
                    </div>
                    <select-option
                      v-if="filterValueEndDropDown"
                      :options="Object.keys(iconTextMatch)"
                      :default="'='"
                      @input="handleFilterConditionEnd"
                      @close="filterValueEndDropDown = false"
                    />
                  </div>
                  <input
                    v-if="filterBy === 'number'"
                    ref="endValue"
                    v-model="filterValueEnd"
                    type="number"
                    placeholder="Enter end value"
                    @keydown="handleInputKeyDown"
                  />
                  <input
                    v-if="filterBy === 'text'"
                    ref="endValue"
                    v-model="filterValueEnd"
                    type="text"
                    placeholder="Enter second text"
                    @keydown="handleInputKeyDown"
                  />
                  <input
                    v-if="dateInputRequireEnd"
                    ref="endValue"
                    v-model="filterValueEnd"
                    type="date"
                    @keydown="handleInputKeyDown"
                  />
                  <input
                    v-if="timeInputRequireEnd"
                    ref="endValue"
                    v-model="filterValueEnd"
                    type="time"
                    @keydown="handleInputKeyDown"
                  />
                </div>
              </div>
            </div>
          </div>

          <filter-sub-menu
            v-else-if="option.type !== 'text' && option.id === currentItemID && option.hasChild"
            :option="option"
            @close="closeActiveBox"
            @setSubItem="setSubItem"
          />
        </div>
      </div>

      <div v-if="data.sections[1] && index == 1" class="section__options">
        <div v-for="(option, i) in data.sections[1].options" :key="i">
          <div
            class="section__option"
            :class="{ 'section__option--active': option.id === currentItemID, disabled: option?.disabled }"
          >
            <radio-box
              :item="option"
              :is-checked="option.id === currentItemID && index === 1"
              @passItem="toggleChildren"
            />
          </div>
          <div v-if="option.default" class="colorFilterDefault" :class="{ colorFilteShadow: option.showAllOptions }">
            <div class="colorFilter__colors">
              <div
                v-for="(item, index) in option.children.options.slice(
                  0,
                  option.showAllOptions ? option.children.options.length : 11
                )"
                :key="index"
                class="colorFilter__color"
                :class="{ selectedColor: option.children.options.indexOf(subMenuItem) === index }"
                :style="{
                  backgroundColor:
                    index === subIndex && currentItemID == option.id ? applyAlpha(item.bgColor, 0.5) : item.bgColor,
                }"
                @click="selectSubItem(item, $event)"
                @mouseenter="subIndex = index"
                @mouseleave="subIndex = null"
              ></div>

              <i
                class="colorFilterDefault__icon"
                :class="['icon-Dropdown-2', { rotateDown: option.showAllOptions }]"
                @click="expandElements(option, $event)"
              ></i>
            </div>
            <div v-if="option.showAllOptions" class="colorFilter__fill">No Fill</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="data.search && index === 0" :style="{ padding: '0px 22px' }">
      <div class="search">
        <radio-box
          :item="data.search"
          :is-checked="data.search.id === currentItemID"
          @passItem="currentItemID = '16'"
        />
        <div class="search__field">
          <input
            ref="searchInput"
            v-model="searchQuery"
            type="text"
            class="search__input"
            @input="handleInput"
            @focus="handleFocus"
            @blur="handleBlur"
            @keydown="handleSearchkeydown"
          />
          <label for="">{{ data.search.value }}</label>
          <i v-if="showSearchIcon" class="icon-search search"></i>
          <i v-if="showCloseIcon" class="icon-close" @click="handleBlur"></i>
        </div>
      </div>
    </div>

    <div v-if="data.serachOptions && index === 0" class="searchItemsWrappers">
      <div class="searchOptions">
        <div class="searchItems">
          <label>
            <input type="checkbox" :checked="allSelected" @change="selectAllValues" />
            (Select All)
          </label>
          <label>
            <input v-model="selectedValues" type="checkbox" value="" />
            (Blanks)
          </label>
          <div v-if="filteredValues.length > 0">
            <label v-for="value in filteredValues" :key="value">
              <input v-model="selectedValues" type="checkbox" :value="value" />
              {{ value }}
            </label>
          </div>
          <div v-else class="noMatchFound">
            <i class="icon-no-matchh"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="section__button">
      <custom-button
        button-class="btn btn-default btn-primary"
        style="font-size: 12px"
        :mode="!canApplyFilter || filterBy === 'text'"
        data-test-id="apply-filter"
        @click="applyFilter"
        >Apply</custom-button
      >
    </div>
  </div>
</template>

<script>
import CustomButton from "../../commons/CustomButton.vue";
import FilterSubMenu from "./FilterSubMenu.vue";
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";
import RadioBox from "../../commons/RadioBox.vue";
import SelectOption from "../../commons/SelectOption.vue";
import { icons } from "../../../utils/icons";
import { NumberConditions, TextConditions, DateConditions, TimeConditions } from "../../../utils/structureTableUtils";
import { NumberFormats, getEditModeValue } from "../../../utils/DataTypeUtils";
import { hfInstance } from "../../../store/Cells";
import DesignerMixin from "../DesignerMixin";
import { iconTextMatch, data } from "../../../utils/constants";

export default {
  components: {
    CustomButton,
    FilterSubMenu,
    RadioBox,
    SelectOption,
  },
  mixins: [DesignerMixin],
  props: {
    isVisible: Boolean,
    x: Number,
    y: Number,
  },
  data() {
    return {
      sortDirection: null,
      filterBy: "none",
      filterCondition: "Choose One",
      filterConditionEnd: "Choose One",
      filterValue: "",
      filterValueStart: "",
      filterConditionJoin: "AND", // to store AND or OR condition
      filterValueEnd: "",
      searchQuery: "",
      selectedValues: [],
      allSelected: false,
      title: "title",
      values: [],
      filterValueDropDown: false,
      filterValueEndDropDown: false,
      subIndex: -1,
      icons,
      startWith: "=",
      endWith: "=",
      iconTextMatch,
      data,
      subMenuItem: null,
      currentItemID: "01",
      isParent: true,
      index: 0,
      keyPressed: null,
      previousScope: null,
      showCloseIcon: false,
      showSearchIcon: false,
    };
  },
  computed: {
    filteredValues() {
      return this.values.filter((value) => (value + "")?.toLowerCase().includes(this.searchQuery?.toLowerCase()));
    },
    activeTable() {
      return this.$store.getters["table/activeTable"]();
    },
    columnValues() {
      return this.$store.getters["table/columnValues"](this.selectedCellId);
    },
    columnIndex() {
      return this.$store.getters["table/columnIndexInTable"]();
    },
    tableValues() {
      return this.$store.getters["table/tableDataValues"](this.activeTable);
    },
    selectedCellId() {
      return this.$store.getters["table/selectedCellId"]();
    },
    filter() {
      return this.$store.getters["table/getFilterByCellId"](this.selectedCellId, this.activeTable);
    },
    filterOptions() {
      let options = [];

      switch (this.filterBy) {
        case NumberFormats.Number:
          options = ["Choose One", ...Object.values(NumberConditions)];
          break;
        case NumberFormats.Text:
          options = ["Choose One", ...Object.values(TextConditions)];
          break;
        case NumberFormats.Date:
        case NumberFormats.ShortDate:
        case NumberFormats.LongDate:
          options = ["Choose One", ...Object.values(DateConditions)];
          break;
        case NumberFormats.Time:
          options = ["Choose One", ...Object.values(TimeConditions)];
          break;
        default:
          options = ["Choose One", ...Object.values(TextConditions)];
          break;
      }

      return options;
    },

    canApplyFilter() {
      return (
        this.selectedValues.length > 0 ||
        (this.filterCondition !== "Choose One" && this.filterValue !== "") ||
        (this.filterBy == NumberFormats.Date && !this.dateInputRequire && this.filterCondition !== "Choose One") ||
        (this.filterBy == NumberFormats.Time && !this.timeInputRequire && this.filterCondition !== "Choose One")
      );
    },

    dateInputRequire() {
      return (
        this.filterBy === NumberFormats.Date &&
        (this.filterCondition === "Equals" || this.filterCondition === "Before" || this.filterCondition === "After")
      );
    },
    dateInputRequireEnd() {
      return (
        this.filterBy === NumberFormats.Date &&
        (this.filterConditionEnd === "Equals" ||
          this.filterConditionEnd === "Before" ||
          this.filterConditionEnd === "After")
      );
    },
    timeInputRequire() {
      return (
        this.filterBy === NumberFormats.Time &&
        (this.filterCondition === "Equals" || this.filterCondition === "Before" || this.filterCondition === "After")
      );
    },
    timeInputRequireEnd() {
      return (
        this.filterBy === NumberFormats.Time &&
        (this.filterConditionEnd === "Equals" ||
          this.filterConditionEnd === "Before" ||
          this.filterConditionEnd === "After")
      );
    },
    popupStyle() {
      return {
        top: `${this.y}px`,
        left: `${this.x}px`,
      };
    },
  },
  watch: {
    selectedValues(newValues) {
      this.allSelected = newValues.length === this.values.length + 1; // +1 to include "blanks"
    },

    filterValue(newValue) {
      if (newValue) {
        this.selectedValues = []; // Clear selectedValues when filterValue is not empty
      }
    },
    subIndex(newVal) {
      const startInput = Array.isArray(this.$refs.startValue) ? this.$refs.startValue[0] : this.$refs.startValue;
      const endInput = Array.isArray(this.$refs.endValue) ? this.$refs.endValue[0] : this.$refs.endValue;

      if (newVal === 1) {
        startInput?.focus();
      } else if (newVal === 3) {
        endInput?.focus();
      } else {
        startInput?.blur?.();
        endInput?.blur?.();
      }
    },

    currentItemID(newVal) {
      if (newVal == this.data.search.id) {
        this.$refs.searchInput?.focus();
      } else {
        this.$refs.searchInput?.blur();
      }
    },
  },

  mounted() {
    this.initialValue();
    this.setTransform();
    this.setScope();
  },

  beforeUnmount() {
    // // Clean up hotkeys when the component is destroyed
    this.$store.dispatch("setScope", this.previousScope);
    hotkeys.unbind("*,tab,escape,space,shift+tab,right,left", HotkeyScopes.FilterOptions);
  },
  methods: {
    selectSubItem(option, event) {
      event.preventDefault();
      this.subMenuItem = option;
      this.data.sections.forEach((section) => {
        section.options = section.options.map((item) => {
          if (item.disabled) {
            return {
              ...item,
              disabled: false, //
            };
          }
          return item;
        });
      });
    },
    applyAlpha(color, alpha) {
      if (color.startsWith("#")) {
        // Convert hex to rgba
        const bigint = parseInt(color.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
      }
      // If already rgba() or something else, just return original
      return color;
    },
    expandElements(option, event) {
      event.preventDefault();
      this.setActiveOption(option);
      this.resetAllDefaultOptions();
      this.collapseExpandOptionStyle(option, !option.showAllOptions);
    },
    setTransform() {
      const popupElement = document.querySelector(".filterWrapper");

      // Get bounding rectangles for parent and popup
      const popupBounds = popupElement.getBoundingClientRect();

      let translateX = "0";
      let translateY = "0";

      // Check for horizontal overflow (right edge of popup beyond viewport or parent)
      if (popupBounds.right > window.innerWidth) {
        translateX = "-300px"; // Adjust X if overflowing on the right side
      }

      // Check for vertical overflow (bottom edge of popup beyond viewport or parent)
      if (popupBounds.bottom > window.innerHeight) {
        const offset = window.innerHeight - popupBounds.bottom;
        translateY = `${Math.round(offset)}px`; // Adjust Y if overflowing on the bottom
      }
    },
    async sort(direction) {
      this.sortDirection = direction;
      await this.$store.dispatch("table/sortTable", direction);
    },
    async applyFilter() {
      const filterCriteria = {
        cellId: this.selectedCellId,
        type: this.filterBy,
        condition1: this.filterCondition,
        value1: this.filterValue,
        condition2: this.filterConditionEnd,
        value2: this.filterValueEnd,
        logicalOperator: this.filterConditionJoin,
        selectedValues: this.selectedValues,
      };
      await this.$store.dispatch("table/updateTableFilter", { table: this.activeTable, filter: filterCriteria });
      hotkeys.trigger("down", HotkeyScopes.ProcessDesigner);
      hotkeys.trigger("up", HotkeyScopes.ProcessDesigner);
      this.closePopup();
    },
    clearFilter() {
      this.$store.dispatch("table/deleteTableFilter", { table: this.activeTable, cellId: this.selectedCellId });
      this.filterCondition = "Choose One";
      this.filterValue = "";
      this.filterValueStart = "";
      this.filterValueEnd = "";
      this.searchQuery = "";
      this.selectedValues = [];
      this.allSelected = false;
    },
    selectAllValues(event) {
      if (event.target.checked) {
        this.selectedValues = this.values.concat("blanks");
      } else {
        this.selectedValues = [];
      }
    },
    closePopup() {
      this.$emit("close");
    },
    initialValue() {
      // set the initial value for sorting
      if (this.activeTable.view.sortApplied.cellId == this.selectedCellId) {
        this.sortDirection = this.activeTable.view.sortApplied.order;
      }
      const filter = this.filter;
      const [columnIndex, rowIndex] = this.getCellIndexById(this.selectedCellId);

      this.title = this.getCellValue(rowIndex, columnIndex);
      // set values for filter list
      const uniqueValues = new Set();
      const filteredValues = this.columnValues.filter((item) => this.getRowVisibility(item.rowId));
      const range = this.$store.getters["table/columnRangeExcludeHeader"](this.selectedCellId);
      const cellIds = this.$store.getters["cells/rangeIds"](range);
      let dataTypes = new Set();
      cellIds.forEach((id) => {
        const colRowIndes = this.$store.getters["cells/getCellCoordinate"](id);
        const activeCellValue = hfInstance.getCellValue({
          sheet: this.currentSheet.sheetId,
          row: colRowIndes[1],
          col: colRowIndes[0],
        });
        if (!activeCellValue) return;
        const properties = this.$store.getters["rangeStyle/properties"](colRowIndes[0], colRowIndes[1]);
        if (properties.dataType == NumberFormats.ShortDate || properties.dataType == NumberFormats.LongDate) {
          dataTypes.add(NumberFormats.Date);
          uniqueValues.add(getEditModeValue(NumberFormats.Date, activeCellValue));
        } else if (properties.dataType) {
          dataTypes.add(properties.dataType);
          uniqueValues.add(getEditModeValue(properties.dataType, activeCellValue));
        } else {
          uniqueValues.add(activeCellValue);
        }
      });
      if (dataTypes.size != 1) {
        this.filterBy = NumberFormats.Text;
      } else {
        this.filterBy = [...dataTypes][0];
      }
      this.values = [...uniqueValues];
    },

    setSelectedValues(values, filterRegex) {
      let selectedValues = new Set();
      values.forEach(({ rowId, value }) => {
        if (filterRegex.test(value)) {
          selectedValues.add(value);
        }
      });
      return [...selectedValues];
    },
    toggleAndOR(item) {
      this.filterConditionJoin = item.value;
    },
    toggleFilterDropDown() {
      this.filterValueDropDown = !this.filterValueDropDown;
    },
    toggleFilterValueEndDropDown() {
      this.filterValueEndDropDown = !this.filterValueEndDropDown;
    },
    handleInputKeyDown(e) {
      const key = e.key;

      switch (true) {
        case key === "Tab" && !e.shiftKey:
        case key === "ArrowRight":
          e.preventDefault();
          this.handleSubMenuNavigation("forward");
          break;

        case key === "ArrowLeft":
        case key === "Tab" && e.shiftKey:
          e.preventDefault();
          this.handleSubMenuNavigation("backward");
          break;

        case key === "Escape":
          e.preventDefault();
          e.target.blur(); // Correctly blurs the input element
          break;
      }
    },

    handleSubMenuNavigation(direction = "forward") {
      const option = this.data.sections[this.index].options.find((option) => option.id === this.currentItemID);

      if (!option || !option.children) return;
      const total = option.children.options.length;
      if (direction === "forward") {
        this.subIndex = (this.subIndex + 1) % total;
      } else {
        this.subIndex = (this.subIndex - 1 + total) % total;
      }
    },
    handleFilterConditionEnd(value) {
      this.endWith = value;
      this.filterConditionEnd = this.iconTextMatch[value];
    },
    handleFilterCondition(value) {
      this.startWith = value;
      this.filterCondition = this.iconTextMatch[value];
    },
    updateOption(optionId, updater) {
      this.data.sections.forEach((section) => {
        section.options = section.options.map((item) => {
          if (item.id === optionId) {
            return updater(item);
          }
          return item;
        });
      });
    },

    setSubItem(option) {
      this.subMenuItem = option;
      this.closeActiveBox();
    },

    setParent(id, index) {
      this.currentItemID = id;
      this.index = index;
    },

    collapseExpandOptionStyle(option, value) {
      this.updateOption(option.id, (item) => ({
        ...item,
        showAllOptions: value,
      }));
    },

    closeActiveBox() {
      if (!this.isParent) {
        const option = this.data.sections[this.index].options.find((option) => option.id === this.currentItemID);
        if (option?.default) {
          this.collapseExpandOptionStyle(option, false);
        }
        this.currentItemID = "01";
        this.isParent = true;
        this.subIndex = 0;
      } else {
        this.$emit("close");
      }
    },

    handleTabNavigation() {
      this.index = (this.index + 1) % this.data.sections.length;
    },

    handleSelection(id) {
      this.currentItemID = id;

      if (id === "01") {
        this.index = 0;
        this.isParent = true;
        return;
      }

      if (id === "02") {
        this.index = 1;
        this.isParent = true;
        return;
      }

      const item = this.data.sections[this.index].options.find((option) => option.id === id);
      if (!item) return;

      this.isParent = false;

      switch (item.type) {
        case "cusSort":
          this.$store.dispatch("pdesign/toggleCustomSort");
          this.$emit("close");
          break;

        case "clear":
          this.clearFilter();
          break;

        case "sort":
          this.sort(item.direction);
          break;
      }

      this.resetAllDefaultOptions();

      if (item.default) {
        this.collapseExpandOptionStyle(item, !item.showAllOptions);
      }
    },

    handleFocus() {
      this.showSearchIcon = true;
      this.currentItemID = "16";
    },
    handleBlur() {
      this.showSearchIcon = false;
      this.showCloseIcon = false;
      this.index = 0;
      this.currentItemID = "01";
      this.searchQuery = "";
    },

    handleInput(event) {
      event.preventDefault();
      if (this.searchQuery.length > 0) {
        this.showSearchIcon = false;
        this.showCloseIcon = true;
      } else {
        this.showCloseIcon = false;
        this.showSearchIcon = true;
      }
    },
    handleSearchkeydown(event) {
      switch (event.key) {
        case "Escape":
        case "Tab":
          event.preventDefault();
          this.handleBlur();
          break;
      }
    },

    setActiveOption(option) {
      const isSame = this.currentItemID === option.id;
      this.currentItemID = isSame ? "01" : option.id;
      this.isParent = isSame; // true if setting to "01", false otherwise
    },

    setScope() {
      this.previousScope = hotkeys.getScope();
      this.$store.dispatch("setScope", HotkeyScopes.FilterOptions);
      hotkeys("tab,shift+tab,right,left", HotkeyScopes.FilterOptions, (event, handler) => {
        event.preventDefault();
        if (this.isParent) {
          this.handleTabNavigation();
        } else {
          const key = handler.key;
          if (key === "tab" || key === "right") {
            this.handleSubMenuNavigation("forward");
          } else if (key === "shift+tab" || key === "left") {
            this.handleSubMenuNavigation("backward");
          }
        }
      });

      hotkeys("space", HotkeyScopes.FilterOptions, (event) => {
        event.preventDefault();
        const option = this.data.sections[this.index].options.find((option) => option.id === this.currentItemID);
        if (option?.type !== "text") return;
        // Determine which select should be toggled based on subIndex
        if (this.subIndex === 0) {
          this.toggleFilterDropDown();
        } else if (this.subIndex === 2) {
          this.toggleFilterValueEndDropDown();
        }
      });
      hotkeys("escape", HotkeyScopes.FilterOptions, (event) => {
        event.preventDefault();
        this.closeActiveBox();
      });

      hotkeys("*", HotkeyScopes.FilterOptions, (event, handler) => {
        event.preventDefault();
        const isNumKey = event.code.startsWith("Numpad") || event.code.startsWith("Digit");
        if (!isNumKey) return;

        if (this.keyPressTimeout) clearTimeout(this.keyPressTimeout);

        const pressedKey = event.key;

        // If it's the first keypress
        if (this.keyPressed === null) {
          if (/^\d$/.test(pressedKey)) {
            this.keyPressed = pressedKey;
          } else {
            this.keyPressed = null;
            return;
          }
        } else {
          // If second digit is entered, complete the selection
          this.keyPressed += pressedKey;
          const selectedNumber = parseInt(this.keyPressed, 10);

          if (selectedNumber == "17") {
            this.filterConditionJoin = "AND";
            this.keyPressed = null;
            return;
          }
          if (selectedNumber == "18") {
            this.filterConditionJoin = "OR";
            this.keyPressed = null;
            return;
          }

          if (selectedNumber >= 1 && selectedNumber <= 20) {
            this.handleSelection(this.keyPressed.padStart(2, "0"));
          }

          // Reset after processing
          this.keyPressed = null;
          return;
        }

        // If waiting for a second digit, reset after a short timeout
        this.keyPressTimeout = setTimeout(() => {
          this.keyPressed = null;
        }, 700);
      });
    },

    toggleChildren(option) {
      this.setActiveOption(option);

      switch (option.type) {
        case "clear":
          this.clearFilter();
          break;

        case "sort":
          this.sort(option.direction);
          break;

        case "cusSort":
          this.$store.dispatch("pdesign/toggleCustomSort");
          this.$emit("close");
          break;
      }
      this.resetAllDefaultOptions();
      if (option.default) {
        this.collapseExpandOptionStyle(option, !option.showAllOptions);
      }
    },

    resetAllDefaultOptions(sectionIndex = 1) {
      this.data.sections[sectionIndex].options = this.data.sections[sectionIndex].options.map((item) => ({
        ...item,
        showAllOptions: false,
      }));
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.activeTab {
  font-weight: bold;
}

.selectedColor {
  border: 2px solid @kk-color-primary-blue;
}

.selected {
  gap: 0;
  padding: 4px 8px;
}

.textFilterWrapper {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  padding: 10px 24px;
  border-radius: 4px;
  box-shadow: 0px 4px 4px rgba(8, 50, 119, 0.2);
  background: @kk-color-white;
}

.textfilter,
.textfilter__andOr {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.textfilter {
  &__dropdown {
    position: relative;
    border-radius: 4px;
    border: 1px solid rgba(8, 50, 119, 0.2);
    color: #c0c0c0;
    &:hover,
    .isOpen {
      background-color: @kk-sky-blue;
      color: @kk-color-primary-blue;
    }
    div.items {
      padding: 0;
      text-align: center;
      &__item {
        padding: 0;
      }
    }
  }
  &__input,
  &__text {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 1rem;
  }

  &__input {
    gap: 0.5rem;

    input {
      flex: 1;
      height: 32px;
      border: 1px solid rgba(8, 50, 119, 0.2);
      border-radius: 4px;
      color: @kk-color-primary-blue;
      padding: 5px 10px;
      &:focus-within {
        border: 1px solid @kk-color-royal-blue;
      }
      &::placeholder {
        color: rgba(8, 50, 119, 0.35);
      }
    }
  }

  &__input {
    input.active,
    div.active {
      border: 1px solid @kk-color-royal-blue;
    }
  }

  &__text {
    justify-content: flex-start;
    label {
      gap: 0.5rem;
    }
  }
}

.search {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  border-radius: 2px;

  &__field {
    flex: 1;
    position: relative;
    border: 1px solid rgba(8, 50, 119, 0.2);
    border-radius: 4px;

    label {
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translate(5%, -50%);
      background: @kk-color-white;
      font-size: 12px;
      padding: 0 3px;
      color: #c0c0c0;
    }

    i {
      color: #8398bb;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translate(0, -50%);
      cursor: pointer;
    }

    &:hover {
      border: 1px solid @kk-color-primary-blue;
      label {
        color: @kk-color-primary-blue;
        font-weight: bold;
      }
    }

    &:focus-within {
      border: 1px solid @kk-color-royal-blue;

      label {
        top: 0%;
        transform: translateY(-50%);
        color: @kk-color-royal-blue;
        font-size: 11px;
        font-weight: bold;
      }
    }
  }

  &__input {
    width: 100%;
    color: @kk-color-primary-blue;
    padding-left: 0.7rem;
    height: 28px;

    ::placeholder {
      color: rgba(8, 50, 119, 0.35);
    }

    i .search {
      display: none;
    }

    &:focus {
      outline: none;
    }
  }
}

.filterBox {
  display: flex;
  gap: 1rem;
  padding: 0px 22px;

  &__active {
    color: @kk-color-primary-blue;
  }
  &__sort,
  &__filter {
    display: flex;
    gap: 0.5rem;
    span {
      cursor: pointer;
    }
  }

  &__devider {
    width: 1px;
    background: #eaedf1;
  }

  &__seperator {
    background: #eaedf1;
    height: 1px;
    width: 90%;
    margin: 0 auto;
  }
}

.filterWrapper {
  position: absolute;
  width: 18.75rem;
  min-width: 12.5rem;
  min-height: 36rem;
  overflow: auto;
  resize: both;
  padding: 22px 0px;
  background-color: @kk-color-white;
  box-shadow: 1px 1px 5px rgba(8, 50, 119, 0.15), -1px -1px 5px rgba(8, 50, 119, 0.15);
  border-radius: 6px;
  z-index: 15;
  color: @kk-color-primary-blue;
}

.section,
.section__options,
.filterSort {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.filterWrapper,
.searchItems {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.section {
  &__label {
    font-weight: 500;
    font-size: 1rem;
  }

  &__option {
    display: flex;
    align-items: center;
    gap: 1rem;
    position: relative;

    &.disabled {
      color: rgba(8, 50, 119, 0.5);
    }

    label {
      gap: 0.5rem;
      cursor: pointer;
      width: 100%;
    }

    &:hover,
    &--active {
      background-color: @kk-sky-blue;
      .option__id {
        background: @kk-color-primary-blue;
        color: @kk-color-white;
      }
    }

    &--text {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  &__button {
    text-align: end;
    padding-right: 22px;
    margin-top: auto;

    button {
      background: @kk-cancel-btn-color;
    }
  }
}

.searchItemsWrappers {
  padding: 0 22px;
  margin-left: 1.8rem;
  .noMatchFound {
    text-align: center;
    font-size: 4rem;
  }
}

.searchOptions {
  height: 12rem;
  overflow-y: auto;
  min-height: 8rem;
  padding: 10px;
  border: 1px solid #dfe4ed;
  border-radius: 5px;
}

.searchItems {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 12px;
    bottom: 12px;
    border-right: 1px solid #dfe4ed;
  }

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    margin-left: 18px;
    gap: 1rem;

    &::after {
      content: "";
      position: absolute;
      width: 10%;
      left: -18px;
      border-bottom: 1px solid #dfe4ed;
      z-index: -1;
    }
  }

  /* Hide the default checkbox */
  input[type="checkbox"] {
    appearance: none; /* Removes the default styling */
    -webkit-appearance: none; /* Safari support */
    width: 16px;
    height: 16px;
    border: 1px solid #98a5bb;
    border-radius: 3px;
    cursor: pointer;
    outline: none;
  }

  /* Unchecked state */
  input[type="checkbox"] {
    background-color: @kk-color-white;
  }

  /* Checked state */
  input[type="checkbox"]:checked {
    border: none;
    background-color: @kk-color-primary-blue; /* Checkbox color */
  }

  /* Tick styling */
  input[type="checkbox"]:checked::after {
    content: "";
    display: block;
    width: 16px;
    height: 16px;
    background: url("@/assets/checkmark.svg");
    background-size: cover;
  }
}

.section__options {
  gap: 0.5rem;
}

.section__option {
  padding: 4px 22px;
  border-radius: 2px;
}
</style>
